import { useMemo } from 'react';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import type { ModuleManifest } from '@buildex/module-contract';
import { CabinetLayout } from './layout/CabinetLayout';
import { HomePage } from '@/pages/home/HomePage';
import { NotFoundPage } from '@/pages/not-found/NotFoundPage';
import { NoModulesPage } from '@/pages/no-modules/NoModulesPage';

/**
 * Дерево роутов собирается из манифестов активных модулей (§5, шаг 3).
 * Корень — Главная: «дорожка» запуска объекта + блоки модулей (сводные, список объектов).
 */
function buildRouter(manifests: ModuleManifest[]) {
  return createBrowserRouter([
    {
      path: '/',
      element: <CabinetLayout manifests={manifests} />,
      children: [
        {
          index: true,
          element: manifests.length > 0 ? <HomePage manifests={manifests} /> : <NoModulesPage />,
        },
        ...manifests.map((manifest) => ({
          path: manifest.basePath.replace(/^\//, ''),
          children: manifest.routes,
        })),
        { path: '*', element: <NotFoundPage /> },
      ],
    },
  ]);
}

interface CabinetRouterProps {
  manifests: ModuleManifest[];
}

export function CabinetRouter({ manifests }: CabinetRouterProps) {
  const router = useMemo(() => buildRouter(manifests), [manifests]);
  return <RouterProvider router={router} />;
}
